import { z } from 'zod'
import type {HttpClient} from "@jantm/model-core";
import {createStudentApi} from "@/api/wiser/student.ts";
import {defineModel} from '@jantm/model-core'
import StudentFullListItem from "@/templates/Wiser/StudentFullListItem.vue";
import StudentFullDetail from "@/templates/Wiser/StudentFullDetail.vue";
import {optionalStringSchema} from "@/types/global.ts";
export const studentSchema = z.object({
  id: z.int(),
  title: optionalStringSchema,
})

export type Student = z.infer<typeof studentSchema>

export const studentCollectionSchema = z.array(studentSchema)

export type StudentCollection = z.infer<typeof studentCollectionSchema>

export const studentFilterSchema = z.object({
  fields: z.array(studentSchema.keyof()).nullish().optional(),
  page: optionalStringSchema.default('1'),
  perPage: optionalStringSchema.default('25'),
  filters: optionalStringSchema,
})
export type StudentFilter = z.infer<typeof studentFilterSchema>


export type StudentFilters = {
  id?: string
  title?: string
}

export interface CreateStudentModelOptions {
  client: HttpClient
  /** Override when this model does not live at `/api/students`. */
  endpoint?: string
}

export function createStudentModel(options: CreateStudentModelOptions) {
  return defineModel({
    name: 'Student',
    schema: studentSchema,
    collectionSchema: studentCollectionSchema,
    filterSchema: studentFilterSchema,
    api: createStudentApi(options.client, options.endpoint),
    identify: (student: Student) => String(student.id),
    templates: { FullListItem: StudentFullListItem, FullDetail: StudentFullDetail },
    // toItems: (collection) => Object.entries(collection.items).map(([, v]) => v),
    // toTotal: (collection => collection.metadata?.total)
  })
}

export type StudentModel = ReturnType<typeof createStudentModel>

declare module '@jantm/model-core' {
  interface ModelRegistry {
    Student: StudentModel
  }
}
